module.exports = __webpack_public_path__ + "img/2-01-07-technical-wht.df9b5fef.svg";